DNDSimpleAuthRegForm = null
tmout1 = setInterval ()=>
  if $(document).find("#DND--simple-auth-and-reg-form").is("div")
    clearTimeout(tmout1)
    DNDSimpleAuthRegForm = new Vue(
      el: "#DND--simple-auth-and-reg-form"
      data: {
        formState: "checkPhone"
        formField: [
          {
            code: "phone"
            title: "Телефон"
            value: ""
          },
          {
            code: "email"
            title: "E-mail"
            value: ""
          },
          {
            code: "name"
            title: "Имя"
            value: ""
          },
          {
            code: "last_name"
            title: "Фамилия"
            value: ""
          },
          {
            code: "sms_code"
            title: "SMS Код"
            value: ""
          }
        ]
        errorMes: ""
        sms_hash: null
        loadingMode: false
        resendCode: false
        nextTimeForResendCode: 0
        currentTime: 0
        timer: null
      }
      computed: {
        canResendPhoneCode: ()->
          return this.nextTimeForResendCode <= this.currentTime

        timerResendTime: ()->
          if this.nextTimeForResendCode > 0 && this.currentTime > 0
            currentRange = parseInt((this.nextTimeForResendCode - this.currentTime) / 1000)
            if currentRange > 0
              minutes = parseInt(currentRange / 60).toString()
              seconds = parseInt(currentRange - (minutes * 60)).toString()

              if minutes.length < 2
                minutes = "0" + minutes
              if seconds.length < 2
                seconds = "0" + seconds

              return minutes + ":" + seconds
          return "00:00"

        formTitle: ()->
          if location.href.includes('/personal/order/make/') || location.href.includes('/personal/order/make/indexnew.php')
            return "Оформление заказа"
          else if this.formState == "login"
            return "Войти"
          else if this.formState == "checkPhone"
            return "Вход/Регистрация"
          else if this.formState == "reg"
            return "Регистрация"
          else if this.formState == "forgot"
            return "Востановление доступа"
        submitBtnTitle: ()->
          if this.formState == "login"
            return "Войти"
          else if this.formState == "checkPhone"
            return "Войти"
          else if this.formState == "reg"
            return "Регистрация"
          else if this.formState == "forgot"
            return "Выслать доступы"
      }
      methods: {
        getTokenGRC: ()->
          # $(document).find(".g-recaptcha").click()
          captchaVal = $(document).find('#token--g-rc').val()

          return captchaVal

        resetTokenGRC: (cb = ()=>)->
          $this = this
          grecaptcha.ready ->
            grecaptcha.execute('6LdJ1UwkAAAAAE8unC4q854h-_S4eNYc2KuF7P2f', action: 'login').then (token) ->
              document.getElementById('token--g-rc').value = token
              console.log($this.getTokenGRC())
              cb()

        changeFormState: (state)->
          this.formState = state

        getField: (code)->
          return this.formField.find((el)=>
            return el.code == code
          )

        getFieldByCode: (code, field)->
          formField = this.getField(code)
          if formField
            return formField[field]

          return ""

        keyupCodeValue: (val)->
          if val.length == 4
            this.submitBtnClick()

        keyupPhoneValue: (val)->
# if val.indexOf('_') == -1
#   $(document).find('.simple-ar-form--form--field--phone').prop('disabled', true)
#   $(document).find('.simple-ar-form--form--field--phone').prop('disabled', false)
          if val.length == 18
            $(document).find('.simple-ar-form--form--field--phone').prop('disabled', true)
            $(document).find('.simple-ar-form--form--field--phone').prop('disabled', false)
# formField = this.getField("phone")
# if formField
#   formField.value = val
#
# this.setStateByPhoneCheck()

        changePhoneValue: (val)->
          console.log val
          if val
#            if val.length == 18
            formField = this.getField("phone")
            if formField
              if formField.value != val
# if !formField.value
#   this.resendCode = false
#   this.stopTimer()
                formField.value = val



                this.setStateByPhoneCheck()

        setStateByPhoneCheck: ()->
          formField = this.getField("phone")
          if !formField.value
            this.changeFormState("checkPhone")
          else
            this.loadingMode = true

            if this.timer
              this.resendCode = false
              this.stopTimer()
            this.resetTokenGRC(() =>
              $.ajax {
                url: "/ajax/checkPhone.php"
                type: "POST"
                data: {phone: formField.value, grcToken: this.getTokenGRC()},
                success: (data)=>

                  data = JSON.parse(data)
                  if data.sms_hash
                    this.setErrorMes("")
                    this.sms_hash = data.sms_hash
                    this.startTimer()
                    if data.type == "login"
                      this.changeFormState("login")
                    else if data.type == "reg"
                      this.changeFormState("reg")
                  if data.errorMessage
                    this.setErrorMes(data.errorMessage)

                  this.loadingMode = false
              }
            )

        successBtnDisabledState: ()->
          returnClassList = []
          if this.formState == "login"
            phoneField = this.getField("phone")
            smscodeField = this.getField("sms_code")
            if !phoneField.value || !smscodeField.value
              returnClassList.push('btn-disabled')
          else if this.formState == "checkPhone"
            phoneField = this.getField("phone")
            if !phoneField.value
              returnClassList.push('btn-disabled')
          else if this.formState == "reg"
            phoneField = this.getField("phone")
            # emailField = this.getField("email")
            nameField = this.getField("name")
            smscodeField = this.getField("sms_code")
            if !phoneField.value || !nameField.value || !smscodeField.value
              returnClassList.push('btn-disabled')
          else if this.formState == "forgot"
            phoneField = this.getField("phone")
            smscodeField = this.getField("sms_code")
            if !phoneField.value || !smscodeField.value
              returnClassList.push('btn-disabled')

          if this.loadingMode
            returnClassList.push('btn-load')

          return returnClassList

        letsAuth: ()->
          this.loadingMode = true
          phoneField = this.getField("phone")
          smscodeField = this.getField("sms_code")
          this.resetTokenGRC(() =>
            $.ajax {
              url: "/ajax/smsAuth.php"
              type: "POST",
              data: {
                phone: phoneField.value, grcToken: this.getTokenGRC(),
                code: smscodeField.value,
                hash: this.sms_hash
              }
              success: (data)=>
                data = JSON.parse(data)
                if data.stateauth
                  $.ajax {
                    url: "/"
                    type: "GET",
                    success: ()=>
                      location.href = location.href
                  }
                else
                  if(data.errorMessage)
                    this.setErrorMes(data.errorMessage)
                  else
                    this.setErrorMes("Не правильно указан код авторизации")
                  this.loadingMode = false
            }
          )

        letsReg: ()->
          this.loadingMode = true
          phoneField = this.getField("phone")
          emailField = this.getField("email")
          nameField = this.getField("name")
          lastNameField = this.getField("last_name")
          smscodeField = this.getField("sms_code")
          this.resetTokenGRC(() =>
            $.ajax {
              url: "/ajax/smsReg.php"
              type: "POST",
              data: {
                phone: phoneField.value, grcToken: this.getTokenGRC(),
  # email: emailField.value,
                name: nameField.value,
  # last_name: lastNameField.value,
                code: smscodeField.value,
                hash: this.sms_hash
              }
              success: (data)=>
                data = JSON.parse(data)
                if data.stateauth
                  $.ajax {
                    url: "/"
                    type: "GET",
                    success: ()=>
                      location.href = location.href
                  }
                else
                  this.setErrorMes(data.errorMes)
                  this.loadingMode = false
            }
          )

        submitBtnClick: ()->
          if !this.successBtnDisabledState().includes('btn-disabled') && !this.loadingMode
            if this.formState == "login"
              this.letsAuth()
            if this.formState == "reg"
              this.letsReg()

        setErrorMes: (mes)->
          this.errorMes = mes

        addTimeToResend: ()->
          this.currentTime = new Date().getTime()
          this.nextTimeForResendCode = new Date().getTime() + (60 * 1000)

        startTimer: ()->
          this.resendCode = true
          this.addTimeToResend()
          this.timer = setInterval(() =>
            this.currentTime = this.currentTime + 1000
          1000)

        stopTimer: ()->
          if this.timer
            clearTimeout(this.timer)
      }
      watch: {
        currentTime: (time)->
          if time >= this.nextTimeForResendCode && this.timer
            this.stopTimer()
      }
      mounted: ()->
        $(document).find(".is-phone-field-masked").mask("+7 (900) 000-00-00", {clearIfNotMatch: true})

# $(document).on "focus click", ".is-phone-field-masked", ()->
#   console.log $(@).val()
#   if $(@).val() == "+7 (___) ___-__-__" || !$(@).val()
#     $(@)[0].setSelectionRange(4,4)
      destroyed: ()->
        if this.timer
          this.stopTimer()
    )
, 1500
